module.exports = __webpack_public_path__ + "img/home-banner.20d85be4.png";